import {getSheet} from "../sheets";

export function init(view) {
	view.attachEvent("onUndo", (action, row, column, value) => {
		if (action == "header-hide"){
			hideHeaders(view, value);
		}
	});
}

export function hideHeaders(view, state, page){
	let oldState;
	page = page || view.getActiveSheet();

	if (page == view.getActiveSheet()) {
		const grid = view.$$("cells");
		const oldState = !(view._loading_data ? state : grid.config.header);

		if (state == "toggle")
			state = !oldState;

		if(state != oldState){
			grid.config.header = !state;
			view.callEvent("onCommand", [{id:"toolbar-update", name:"hide-headers", value:state}]);

			const firstVisible = grid.isColumnVisible("rowId");
			if((firstVisible && state) || (!firstVisible && !state))
				grid.hideColumn("rowId", {}, true, !!state);

			grid.refreshColumns();
		}
	}
	else{
		const sheet = getSheet(view, page);
		if(sheet){
			if(!sheet.content.table)
				sheet.content.table = {headers: 1};

			oldState = !sheet.content.table.headers;

			if (state === "toggle")
				state = !oldState;

			sheet.content.table.headers = state ? 0 : 1;
		}
		else return;
	}

	if(state != oldState)
		view.callEvent("onAction", ["header-hide", {newValue: state, value: oldState, page}]);
}

export function serialize(view, data){
	data.table.headers = view.$$("cells").config.header ? 1 : 0;
}

export function load(view, data){
	let mode;
	if(data.table && !webix.isUndefined(data.table.headers))
		mode = !data.table.headers;
	hideHeaders(view, mode);
}